// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
/* eslint-disable @typescript-eslint/no-unused-vars */
import { ApiResult, get, post } from "./api_client";
import { GroundTruthResult, IGroundTruthResult, GroundTruthJob, IGroundTruthJob, GroundTruthJobDebugInfo, IGroundTruthJobDebugInfo, GroundTruthRunSummary, IGroundTruthRunSummary, GroundTruthCounterOption, IGroundTruthCounterOption, GroundTruthTrialResult, IGroundTruthTrialResult, FacilityCurrentOccupancy, IFacilityCurrentOccupancy, FacilityCountBaseline, IFacilityCountBaseline } from "../models";
/* eslint-enable @typescript-eslint/no-unused-vars */

export async function upload(facilityId?: string): ApiResult<GroundTruthResult> {
	return post<IGroundTruthResult>(`/api/groundtruth/${ facilityId }`).then(result => result === undefined ? undefined :  new GroundTruthResult(result));
}

export async function uploadAsync(facilityId?: string): ApiResult<GroundTruthJob> {
	return post<IGroundTruthJob>(`/api/groundtruth/${ facilityId }/async`).then(result => result === undefined ? undefined :  new GroundTruthJob(result));
}

export async function getById(id?: string): ApiResult<GroundTruthJob> {
	return get<IGroundTruthJob>(`/api/groundtruth/${ id }`).then(result => result === undefined ? undefined :  new GroundTruthJob(result));
}

export async function getByFacility(facilityId?: string): ApiResult<GroundTruthJob[]> {
	return get<IGroundTruthJob[]>(`/api/groundtruth/facility/${ facilityId }`).then(result => result === undefined ? undefined : result.map(o => new GroundTruthJob(o)));
}

export async function getDebugInfo(id?: string): ApiResult<GroundTruthJobDebugInfo> {
	return get<IGroundTruthJobDebugInfo>(`/api/groundtruth/${ id }/debug`).then(result => result === undefined ? undefined :  new GroundTruthJobDebugInfo(result));
}

export async function getCallerPayload(id?: string): ApiResult<string> {
	return get<string>(`/api/groundtruth/${ id }/caller-payload`);
}

export async function getRuns(limit: number): ApiResult<GroundTruthRunSummary[]> {
		const queryParams = [limit !== undefined ? `limit=${limit}` : undefined]
		var query = queryParams.filter((v) => (v !== undefined)).join('&');
		if (query && query.length)
			query = '?' + query;

	return get<IGroundTruthRunSummary[]>(`/api/groundtruth/runs${query}`).then(result => result === undefined ? undefined : result.map(o => new GroundTruthRunSummary(o)));
}

export async function getCounters(): ApiResult<GroundTruthCounterOption[]> {
	return get<IGroundTruthCounterOption[]>(`/api/groundtruth/counters`).then(result => result === undefined ? undefined : result.map(o => new GroundTruthCounterOption(o)));
}

export async function trial(): ApiResult<GroundTruthTrialResult> {
	return post<IGroundTruthTrialResult>(`/api/groundtruth/trial`).then(result => result === undefined ? undefined :  new GroundTruthTrialResult(result));
}

export async function trialAsync(): ApiResult<GroundTruthTrialResult> {
	return post<IGroundTruthTrialResult>(`/api/groundtruth/trial/async`).then(result => result === undefined ? undefined :  new GroundTruthTrialResult(result));
}

export async function getTrial(runId?: string): ApiResult<GroundTruthTrialResult> {
	return get<IGroundTruthTrialResult>(`/api/groundtruth/trial/${ runId }`).then(result => result === undefined ? undefined :  new GroundTruthTrialResult(result));
}

export async function getTrialDebugInfo(runId?: string): ApiResult<GroundTruthJobDebugInfo> {
	return get<IGroundTruthJobDebugInfo>(`/api/groundtruth/trial/${ runId }/debug`).then(result => result === undefined ? undefined :  new GroundTruthJobDebugInfo(result));
}

export async function getCurrentOccupancy(facilityId?: string): ApiResult<FacilityCurrentOccupancy> {
	return get<IFacilityCurrentOccupancy>(`/api/groundtruth/facility/${ facilityId }/occupancy`).then(result => result === undefined ? undefined :  new FacilityCurrentOccupancy(result));
}

export async function getBaselines(facilityId?: string): ApiResult<FacilityCountBaseline[]> {
	return get<IFacilityCountBaseline[]>(`/api/groundtruth/facility/${ facilityId }/baselines`).then(result => result === undefined ? undefined : result.map(o => new FacilityCountBaseline(o)));
}

export async function setBaseline(facilityId?: string, request?: FacilityCountBaseline): ApiResult<FacilityCountBaseline> {
	return post<IFacilityCountBaseline>(`/api/groundtruth/facility/${ facilityId }/baseline`, request).then(result => result === undefined ? undefined :  new FacilityCountBaseline(result));
}

export async function promoteToBaseline(id?: string): ApiResult<FacilityCountBaseline> {
	return post<IFacilityCountBaseline>(`/api/groundtruth/${ id }/promote`).then(result => result === undefined ? undefined :  new FacilityCountBaseline(result));
}
